import backIcon from "@assets/images/back.svg";
import duplicateIcon from "@assets/images/duplicate.svg";
import ExternalLinkTeal from "@assets/images/external-link-teal.svg";
import XCircleOutLine from "@assets/images/x-circle-outline.svg";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import OrderBeingProcessError from "@saleor/changeOrder/components/OrderBeingProcessError";
import DialogConfirmSplit from "@saleor/changeOrderDomestic/components/DialogConfirmSplit";
import { ItemDetailsTabProps } from "@saleor/changeOrderDomestic/components/ItemDetailsTab";
import ModalInputParameter from "@saleor/changeOrderDomestic/components/ModalInputParameter";
import { WEIGHT_UNIT } from "@saleor/changeOrderDomestic/const";
import {
  getNetPriceForProductGroup1,
  getNetPriceForProductGroup2,
  showIplanButtonCheck
} from "@saleor/changeOrderDomestic/utils";
import { ItemTab } from "@saleor/changeOrderDomestic/views/ViewEditOrder/types";
import DialogSubmitOrder from "@saleor/changeOrderExport/components/DialogSubmitOrder";
import { ViewEditMode } from "@saleor/changeOrderExport/views/ViewEditOrder/types";
import Checkbox from "@saleor/components/Checkbox";
import DatePicker from "@saleor/components/DatePicker";
import DatePickerApplyAll from "@saleor/components/DatePickerApplyAll";
import DecimalFormat from "@saleor/components/DecimalFormat";
import DialogProcessing from "@saleor/components/DialogProcessing";
import MyTypography from "@saleor/components/MyTypography";
import NumberFormat from "@saleor/components/NumberFormat";
import PopoverApplyAll from "@saleor/components/PopoverApplyAll";
import SearchRoute from "@saleor/components/SearchRoute";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import SingleTextField from "@saleor/components/SingleTextField";
import SingleTextFieldUnblock from "@saleor/components/SingleTextField2";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { BIG_ROW_NUMBER_SET } from "@saleor/components/TablePagination/constants";
import { TablePaginationCustom } from "@saleor/components/TablePaginationCustom";
import TextAreaField from "@saleor/components/TextAreaField";
import { REGEX_ONLY_NUMBER, REGEX_ONLY_NUMBER_CHARACTER } from "@saleor/config";
import { checkIsCashSaleOrder } from "@saleor/createOrChangeNotRefContract/utils";
import CashSaleForm from "@saleor/createOrder/components/CashSaleForm";
import { ICashsaleFormValues } from "@saleor/createOrder/components/CashSaleForm/types";
import { DomesticOrderSortField } from "@saleor/createOrderDomestic/urls";
import FullScreenButton from "@saleor/createOrderExport/components/FullScreenButton";
import {
  ContractChangeOrderDomesticQuery,
  GetArOutstandingQueryResult,
  IPlanOrderItemStatus,
  OrderType,
  RealtimePartnerType,
  ReasonForChangeRequestDateEnum,
  useAddSplitOrderLineItemMutation,
  useGet_Realtime_PartnerMutation
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import useNotifier from "@saleor/hooks/useNotifier/useNotifier";
import { renderCollection } from "@saleor/misc";
import { SortPage } from "@saleor/types";
import {
  PROD_CATEG_1,
  PROD_CATEG_2,
  SALE_CATEG_1
} from "@saleor/utils/constants";
import { isKO1KO9 } from "@saleor/utils/data/convertUnit";
import { getRandomNumber } from "@saleor/utils/getRandowNumber";
import { getArrowDirection } from "@saleor/utils/sort";
import classNames from "classnames";
import { FormikProps } from "formik";
import moment from "moment";
import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import SVG from "react-inlinesvg";
import { FormattedNumber, useIntl } from "react-intl";

import DialogSplitError from "../DialogSplitError";
import ModalAddress from "./ModalAddress";
import useStyles from "./styles";
import {
  ConsignmentType,
  DataApplyAllProps,
  DataModalAddressProps,
  typeApplyAll
} from "./types";

export interface ItemDetailsEditTabProps
  extends ItemDetailsTabProps,
    SortPage<DomesticOrderSortField> {
  isSelected: (data) => boolean;
  listElements: any[];
  reset: () => void;
  toggle: (data) => void;
  set: (value) => void;
  dataOrder: ContractChangeOrderDomesticQuery["changeOrder"];
  handleRevertItem: (id, item?) => void;
  orderStatus: string;
  soldToCode: string;
  handleSplitData?: (originalId) => void;
  handleDeleteSplitData?: (itemNo, originalId) => void;
  splitLineId?: string;
  setSplitLineId?: (itemNo) => void;
  refetchChangeOrder?: () => void;
  soNo?: string;
  setViewEditMode?: (viewEditMode: ViewEditMode) => void;
  isOrderInvalid?: boolean;
  onConfirmReloadPage?: Dispatch<SetStateAction<boolean>>;
  formikCashSale?: FormikProps<ICashsaleFormValues>;
  orderAmountAfterVat?: number;
  disabledActionForCashSale?: boolean;
  arOutstandingResult?: GetArOutstandingQueryResult;
}

const tabList = [
  {
    id: "order-information-tab",
    code: ItemTab.tabA,
    title: "ข้อมูลสั่งซื้อ",
    index: "z4",
    first: true
  },
  {
    id: "iplan-tab",
    code: ItemTab.tabB,
    title: "iPlan Details",
    index: "z3",
    first: false
  },
  {
    id: "additional-tab",
    code: ItemTab.tabC,
    title: "Additional Data",
    index: "z2",
    first: false
  },
  {
    id: "cash-sale-tab",
    code: ItemTab.tabD,
    title: "Cash Sale",
    index: "z1",
    first: false
  }
];

const ItemDetailsTabEdit: React.FC<ItemDetailsEditTabProps> = props => {
  const {
    dataOrder,
    currentData,
    listLineOrder,
    setListLineOrder,
    loading,
    hasNextPage,
    hasPreviousPage,
    onNextPage,
    onPreviousPage,
    onNextLastPage,
    onPreviousFirstPage,
    onUpdateListSettings,
    settings,
    isSelected,
    listElements,
    reset,
    toggle,
    set,
    handleRevertItem,
    sort,
    onSort,
    setActiveTab,
    activeTab,
    orderStatus,
    soldToCode,
    handleSplitData,
    handleDeleteSplitData,
    setSplitLineId,
    splitLineId,
    refetchChangeOrder,
    setViewEditMode,
    isOrderInvalid,
    disabledActionForCashSale,
    cashSaleFormProps
  } = props;
  const [{ fullScreen }] = useAppState();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const [reRender, setReRender] = useState<boolean>(false);
  const [openAddress, setOpenAddress] = useState<boolean>(false);
  const [dataModalAddress, setDataModalAddress] = useState<
    DataModalAddressProps
  >({ initAddress: "", id: "" });
  const [dataApplyAll, setDataApplyAll] = useState<DataApplyAllProps>({
    anchorEl: null,
    title: "",
    placeholder: "",
    type: null
  });
  const [openApplyAll, setOpenApplyAll] = useState<boolean>(false);
  const [componentKey, setComponentKey] = useState<number>(0);
  const [openInputParameter, setOpenInputParameter] = useState<boolean>(false);
  const [dataInputParameter, setDataInputParameter] = useState<string>(null);
  const [openConfirmSplit, setOpenConfirmSplit] = useState<boolean>(false);
  const [openLoadingSubmit, setOpenLoadingSubmit] = useState<boolean>(false);
  const [beingProcessMsg, setBeingProcessMsg] = useState<string>("");
  const [isDisableSubmitSplitItem, setIsDisableSubmitSplitItem] = useState<
    boolean
  >(false);
  const [dialogSplitError, setDialogSplitError] = useState(false);
  const [errorSource, setErrorSource] = useState("");
  const [errorItems, setErrorItems] = useState("");
  const classes = useStyles({ activeTab });
  const intl = useIntl();
  const [{ viewEditMode }] = useAppState();
  const notify = useNotifier();

  const isCashSaleOrder = checkIsCashSaleOrder(dataOrder?.orderType);

  const [getShipToData, { data: shipToData }] = useGet_Realtime_PartnerMutation(
    {
      variables: {
        type: RealtimePartnerType.SHIP_TO,
        saleOrgCode: dataOrder?.salesOrg,
        soldToCode,
        piMessageId: getRandomNumber(),
        distributionChannel: dataOrder?.distributionChannel,
        division: dataOrder?.division,
        orderType: OrderType.DOMESTIC
      }
    }
  );

  useEffect(() => {
    getShipToData();
  }, []);

  useEffect(() => {
    if (dataOrder?.salesOrg) {
      getShipToData();
    }
  }, [dataOrder]);

  useEffect(() => {
    if (openAddress) {
      getShipToData();
    }
  }, [openAddress]);

  const [
    handleSubmitSplit,
    { loading: loadingSplitItem }
  ] = useAddSplitOrderLineItemMutation({
    variables: {
      soNo: dataOrder?.soNo,
      originLineItem: {
        itemNo: listLineOrder.find(item => item.id === splitLineId)?.itemNo,
        id: +splitLineId,
        quantity: +listLineOrder.find(item => item.id === splitLineId)?.itemQty
      },
      splitLineItems: listLineOrder
        .filter(item => item.isSplit)
        .map(item => ({
          itemNo: item.itemNo,
          quantity: +item.itemQty,
          requestDate: item.requestDate
        }))
    },
    onCompleted: data => {
      setOpenLoadingSubmit(false);
      if (data?.addSplitOrderLineItem?.status) {
        refetchChangeOrder();
      }
      if (!data?.addSplitOrderLineItem?.errors?.length) {
        setSplitLineId("");
        setViewEditMode(ViewEditMode.EDIT);
      } else {
        setOpenConfirmSplit(false);
        const sourceSystem =
          (data?.addSplitOrderLineItem?.errors?.length >= 2 &&
            data?.addSplitOrderLineItem?.errors[1]?.message === "SAP") ||
          data?.addSplitOrderLineItem?.sapOrderMessages?.length > 0
            ? "SAP"
            : "iPlan";
        setDialogSplitError(true);
        setErrorSource(sourceSystem);
        setErrorItems(
          data?.addSplitOrderLineItem?.errors[0]?.message ||
            data?.addSplitOrderLineItem?.sapOrderMessages[0]?.errorCode +
              " - " +
              data?.addSplitOrderLineItem?.sapOrderMessages[0]?.errorMessage
        );
      }
    },
    onError: error => {
      setOpenLoadingSubmit(false);
      setOpenConfirmSplit(false);
      notify({
        status: "error",
        apiMessage: error?.message,
        sourceSystem: error?.message?.includes("iPlan") ? "iPlan" : "Eordering"
      });
    }
  });

  const onAcknowledgeSplitError = () => {
    setDialogSplitError(false);
    //  checking if R5 flagged or not, for iplan errors, R5 will be flagged
    if (errorSource === "iPlan") {
      refetchChangeOrder();
      setSplitLineId("");
      setViewEditMode(ViewEditMode.VIEW);
    }
  };

  const onOkConfirmSplit = () => {
    setOpenConfirmSplit(true);
    setOpenLoadingSubmit(false);
    handleSubmitSplit();
  };

  const onSubmitSplit = () => {
    const newListLineOrder = [...listLineOrder];
    newListLineOrder.forEach(item => {
      item.errorDate = !item.requestDate;
      item.errorQuantity = !item.quantity;
    });
    setListLineOrder(newListLineOrder);
    const splitError = newListLineOrder.filter(
      item => item.isSplit && (item.errorDate || item.errorQuantity)
    );
    if (!splitError.length) {
      setOpenConfirmSplit(true);
    }
  };

  const isOrderCompletedDelivery = useMemo(
    () => orderStatus === "Completed Delivery",
    [orderStatus]
  );

  const onTabClick = tab => {
    setActiveTab(tab);
  };

  const handleOpenAddress = line => {
    setOpenAddress(true);
    setDataModalAddress({
      initAddress: line.shipTo,
      id: line.itemNo
    });
  };

  const handleCloseAddress = () => {
    setOpenAddress(false);
    setDataModalAddress({ initAddress: "", id: undefined });
  };

  const setApplyPlant = e => {
    if (!isOrderCompletedDelivery) {
      setDataApplyAll({
        type: typeApplyAll.applyPlant,
        title: "Plant",
        placeholder: "ระบุ Plant",
        anchorEl: e.currentTarget,
        maxLength: 4,
        regex: REGEX_ONLY_NUMBER_CHARACTER
      });
      setComponentKey(prev => prev + 1);
      setOpenApplyAll(true);
    }
  };

  const setApplyShippingPoint = e => {
    setDataApplyAll({
      type: typeApplyAll.applyShippingPoint,
      title: "Shipping Point",
      placeholder: "ระบุ Shipping Point",
      anchorEl: e.currentTarget,
      maxLength: 4,
      regex: undefined
    });
    setComponentKey(prev => prev + 1);
    setOpenApplyAll(true);
  };

  const handleApplyAllRequestDate = value => {
    const tempLine = [...listLineOrder];
    tempLine.forEach(item => {
      if (
        !isItemDisabled(item) &&
        !item.hasSplit &&
        !isOrderCompletedDelivery
        // !item.isSplit &&
      ) {
        item.requestDate = value;
      }
    });
    setListLineOrder(tempLine);
  };

  const handleOpenInputParameter = id => {
    setDataInputParameter(id);
    setOpenInputParameter(true);
  };

  useEffect(() => {
    setReRender(prevState => !prevState);
  }, [fullScreen]);

  useEffect(() => {
    setReRender(prevState => !prevState);
    if (containerRef.current) {
      containerRef!.current!.scrollLeft = 0;
    }
  }, [activeTab, viewEditMode]);

  const applyAddressShipTo = value => {
    const tempLine = [...listLineOrder];
    const lineChange = tempLine.find(
      item => item.itemNo === dataModalAddress.id
    );
    lineChange.shipTo = value;
    setListLineOrder(tempLine);
  };

  const handleApplyAll = value => {
    const tempLine = [...listLineOrder];
    if (dataApplyAll.type === typeApplyAll.applyPlant) {
      tempLine.forEach(item => {
        if (!isItemDisabled(item) && !item.hasSplit && !item.isSplit) {
          item.plant = value;
        }
      });
    } else if (dataApplyAll.type === typeApplyAll.applyShippingPoint) {
      tempLine.forEach(item => {
        if (!isItemDisabled(item) && !item.hasSplit && !item.isSplit) {
          item.shippingPoint = value;
        }
      });
    }
    setListLineOrder(tempLine);
    setOpenApplyAll(false);
  };

  const isProductCateg2 = currentData.some(item =>
    PROD_CATEG_2(item.materialGroup1)
  );

  const handleCheckboxAll = () => {
    if (
      listElements.length ===
      listLineOrder.filter(
        item => !isItemDisabled(item, true) && !item.hasSplit && !item.isSplit
      ).length
    ) {
      reset();
      return;
    }
    set(
      listLineOrder
        .filter(
          item => !isItemDisabled(item, true) && !item.hasSplit && !item.isSplit
        )
        .map(item => item.itemNo)
    );
  };

  const handleCheckQuantityByItemStatus = (line, newQuantity: number) => {
    let isError = false;
    let messageError = "";
    if (!isOrderItemCTP(line)) {
      return {
        isError,
        messageError
      };
    }
    if (
      line.itemStatusEn === IPlanOrderItemStatus.PLANNING_CLOSE_LOOP ||
      line.itemStatusEn === IPlanOrderItemStatus.PLANNING_ALLOCATED_X_TRIM ||
      line.itemStatusEn === IPlanOrderItemStatus.PRODUCING ||
      line.itemStatusEn === IPlanOrderItemStatus.FULL_COMMITTED_ORDER ||
      line.itemStatusEn === IPlanOrderItemStatus.COMPLETED_PRODUCTION
    ) {
      if (newQuantity > Number(line.orderQty)) {
        isError = true;
        messageError = "ไม่สามารถเพิ่มจำนวนได้";
      }
      if (
        newQuantity < Number(line.assignQuantity) &&
        line.itemStatusEn !== IPlanOrderItemStatus.COMPLETED_PRODUCTION &&
        line.itemStatusEn !== IPlanOrderItemStatus.FULL_COMMITTED_ORDER
      ) {
        isError = true;
        messageError = "โปรดระบุจำนวนให้มากกว่า Assigned QTY";
      }
    }
    return {
      isError,
      messageError
    };
  };

  const handleChangeField = (event, id, field, extraValue?) => {
    const newValue = event.target.value;
    const newList = [...listLineOrder];
    const lineChange = newList.find(item => item.itemNo === id);
    const isAddNewItemFlow = newList.some(item => item.isNewAddItem);

    if (field === "quantity") {
      const value = parseFloat(event.target.value);
      lineChange.itemQty = value;

      if (lineChange.isSplit) {
        if (lineChange.orderType.substring(0, 3).toUpperCase() === "ATP") {
          const originalId = lineChange.originalId;
          const originLine = newList.find(line => line.id === originalId);
          const maxQuantity = lineChange.originQuantity || 0;

          const lineSameOrigin = newList.filter(
            line => line.originalId === originalId && line.itemNo !== id
          );

          let totalQuantity = value || 0;

          lineSameOrigin.forEach(line => {
            const lineQuantity = line.quantity || 0;
            line.errorQuantity = false;
            totalQuantity += parseInt(lineQuantity, 10);
          });

          lineChange.errorQuantity = !value || totalQuantity >= maxQuantity;
          if (lineChange.errorQuantity) {
            setIsDisableSubmitSplitItem(lineChange.errorQuantity);
            lineChange.errorText = "โปรดระบุจำนวนไม่เกินจำนวนตั้งต้น";
          }
          if (!lineChange.errorQuantity) {
            setIsDisableSubmitSplitItem(lineChange.errorQuantity);
          }
          originLine.itemQty = originLine.originQuantity - totalQuantity;
          if (originLine.itemQty < 0) {
            originLine.itemQty = 0;
          }
        }
        if (
          lineChange.orderType.substring(0, 3).toUpperCase() === "CTP" ||
          !PROD_CATEG_1(lineChange?.materialGroup1)
        ) {
          const originalId = lineChange.originalId;
          const originLine = newList.find(line => line.id === originalId);
          const maxQuantity = lineChange.assignQuantity || 0;

          const lineSameOrigin = newList.filter(
            line => line.originalId === originalId && line.itemNo !== id
          );

          let totalQuantity = value || 0;

          lineSameOrigin.forEach(line => {
            const lineQuantity = line.quantity || 0;
            line.errorQuantity = false;
            totalQuantity += +lineQuantity;
          });
          totalQuantity = parseFloat(totalQuantity?.toFixed(3));
          lineChange.errorQuantity = !value || totalQuantity > maxQuantity;
          if (lineChange.errorQuantity) {
            setIsDisableSubmitSplitItem(lineChange.errorQuantity);
            lineChange.errorText = "โปรดระบุจำนวนไม่เกิน Assigned quantity";
          }
          if (!lineChange.errorQuantity) {
            setIsDisableSubmitSplitItem(lineChange.errorQuantity);
          }

          originLine.itemQty = originLine.originQuantity - totalQuantity;
          if (originLine.itemQty < 0) {
            originLine.itemQty = 0;
          }
        }
      } else if (isOrderInvalid) {
        if (Number(lineChange.originQuantity) < newValue) {
          lineChange.errorQuantity = true;
          lineChange.errorText =
            "ไม่สามารถเพิ่มจำนวนได้ เนื่องจาก Contract Invalid/Completed";
        } else {
          lineChange.errorQuantity = false;
        }
      } else {
        const { isError, messageError } = handleCheckQuantityByItemStatus(
          lineChange,
          value
        );
        if (isError) {
          lineChange.errorQuantity = true;
          lineChange.errorText = messageError;
        } else {
          const remain = lineChange.remainWeight || 0;
          let total = 0;
          const key = `${lineChange.contractProductId}`;
          newList.forEach(line => {
            const lineKey = `${line.contractProductId}`;

            if (isAddNewItemFlow) {
              if (line.isNewAddItem) {
                if (line.itemNo === id) {
                  if (isProductCateg2) {
                    total = total + parseFloat(newValue); // Convert and add
                    return;
                  } else {
                    total += lineChange.weightBase * newValue;
                    return;
                  }
                }
                if (lineKey === key) {
                  if (isProductCateg2) {
                    total = total + parseFloat(line.quantity); // Convert and add
                  } else {
                    total += line.weightBase * line.quantity;
                  }
                }
              }
            } else {
              if (line.itemNo === id) {
                if (isProductCateg2) {
                  total = total + parseFloat(newValue); // Convert and add

                  return;
                } else {
                  total += lineChange.weightBase * newValue;
                  return;
                }
              }
              if (lineKey === key) {
                if (isProductCateg2) {
                  total = total + parseFloat(line.quantity); // Convert and add
                } else {
                  total += line.weightBase * line.quantity;
                }
              }
            }
          });

          lineChange.errorQuantity = !value || total > remain;

          if (isProductCateg2) {
            const remainVal = remain.toFixed(3);
            const roundedRemain = parseFloat(remainVal);
            lineChange.errorQuantity = !value || total > roundedRemain;
          }

          newList.forEach(line => {
            const lineKey = `${line.contractProductId}`;
            if (lineKey === key) {
              if (total <= remain && parseFloat(line.quantity)) {
                line.errorQuantity = false;
              }
            }
          });
        }
      }
    }
    if (field === "requestDate") {
      lineChange.errorDateMessage = "";
      if (newValue !== lineChange[field]) {
        lineChange.isEditRequestDate = true;
      }
      if (
        (lineChange.itemStatusEn ===
          IPlanOrderItemStatus.COMPLETED_PRODUCTION &&
          moment(newValue).isBefore(moment())) ||
        (lineChange.itemStatusEn ===
          IPlanOrderItemStatus.FULL_COMMITTED_ORDER &&
          moment(newValue).isBefore(moment()))
      ) {
        lineChange.errorDate = true;
        lineChange.errorDateMessage = "ไม่สามารถเลือกวันที่ในอดีตได้";
      }
      lineChange.isEditRequestDate =
        moment(newValue, "YYYY-MM-DD").format("DD/MM/YYYY") !==
        lineChange.initRequestDate;

      lineChange.errorDate =
        !newValue ||
        (lineChange.isEditRequestDate &&
          moment(newValue)
            .set("h", 1)
            .isBefore(moment().set("h", 0)));
    }
    if (field === "plant") {
      lineChange.errorPlant = !newValue;
    }

    lineChange[field] = extraValue || newValue;
    lineChange.isChange = true;

    setListLineOrder(newList);
  };

  const onSaveInputParameter = data => {
    const tempLine = [...listLineOrder];
    const lineChange = tempLine.find(item => item.id === dataInputParameter);
    lineChange.inquiryMethod = data.inquiryMethod;
    lineChange.changeConsignmentCode = data.changeConsignmentCode;
    lineChange.ConsignmentType = data.ConsignmentType;
    lineChange.consignmentLocation = data.consignmentLocation;
    lineChange.consignmentTitle = data.consignmentTitle;
    setListLineOrder(tempLine);
    setOpenInputParameter(false);
    setDataInputParameter(null);
  };

  const handleSplitItem = id => {
    if (!loadingSplitItem && !loading) {
      handleSplitData(id);
    }
  };

  const handleDeleteSplit = (itemNo, originalId) => {
    if (!loading) {
      handleDeleteSplitData(itemNo, originalId);
    }
  };

  const getListCheckedUnlimit = listLineOrder.filter(
    item => item.deliveryTolUnlimited
  );

  const getCheckedSelectAllUnlimit = () => {
    const listLineFilterDisable = listLineOrder.filter(
      item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
    );
    const listCheckedFilterDisable = getListCheckedUnlimit.filter(
      item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
    );
    return (
      listLineFilterDisable.length > 0 &&
      listLineFilterDisable.length === listCheckedFilterDisable.length
    );
  };

  const getIndeterminateAllLimit = () => {
    const listLineFilterDisable = listLineOrder.filter(
      item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
    );
    const listCheckedFilterDisable = getListCheckedUnlimit.filter(
      item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
    );
    return (
      listCheckedFilterDisable.length > 0 &&
      listCheckedFilterDisable.length < listLineFilterDisable.length
    );
  };

  const handleClickCheckBoxUnlimitAll = () => {
    const newLine = [...listLineOrder];
    if (getCheckedSelectAllUnlimit()) {
      newLine
        .filter(
          item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
        )
        .forEach(item => (item.deliveryTolUnlimited = false));
    } else {
      newLine
        .filter(
          item => !isItemDisabled(item) && !item.hasSplit && !item.isSplit
        )
        .forEach(item => (item.deliveryTolUnlimited = true));
    }
    setListLineOrder(newLine);
  };

  const isOrderItemCTP = item =>
    item?.orderType?.substring(0, 3).toUpperCase() === "CTP";

  const isFlaggedR5Item = useMemo(
    () => !!listLineOrder.find(line => line.flagR5),
    [listLineOrder]
  );

  const hasAnyFlagR5 = useMemo(
    () => !!listLineOrder.some(line => line.flagR5),
    [listLineOrder]
  );
  const isItemDisabled = (item, ischeckR5 = true) => {
    if (
      PROD_CATEG_2(item.materialGroup1) &&
      (item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY ||
        item.itemStatusEn === IPlanOrderItemStatus.PARTIAL_DELIVERY)
    ) {
      return false;
    }

    // Your existing conditions for item disabling.
    return (
      item.statusCancel === "Cancel" ||
      item.statusCancel === "Delete" ||
      item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY ||
      item.itemStatusEn === IPlanOrderItemStatus.CANCEL ||
      isOrderCompletedDelivery ||
      (ischeckR5 ? isFlaggedR5Item : false) ||
      (!item.isSplit && !!splitLineId)
    );
  };

  const isItemDisabledRequestDateChangeReason = (item, ischeckR5 = true) => {
    if (
      (PROD_CATEG_2(item.materialGroup1) &&
        (item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY ||
          item.itemStatusEn === IPlanOrderItemStatus.PARTIAL_DELIVERY)) ||
      (PROD_CATEG_1(item.materialGroup1) &&
        item.itemStatusEn !== IPlanOrderItemStatus.CANCEL)
    ) {
      return false;
    }
    // copy of  isItemDisabled  , but the true case specifically used for  field RequestDateChangeReason
    return (
      item.statusCancel === "Cancel" ||
      item.statusCancel === "Delete" ||
      item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY ||
      item.itemStatusEn === IPlanOrderItemStatus.CANCEL ||
      isOrderCompletedDelivery ||
      (ischeckR5 ? isFlaggedR5Item : false) ||
      (!item.isSplit && !!splitLineId)
    );
  };

  const isDisableCtpWithCondition = item => {
    if (
      item.orderType === "CTP" &&
      (item.itemStatusEn === IPlanOrderItemStatus.PLANNING_ALLOCATED_X_TRIM ||
        item.itemStatusEn === IPlanOrderItemStatus.PLANNING_CLOSE_LOOP ||
        item.itemStatusEn === IPlanOrderItemStatus.PRODUCING ||
        item.itemStatusEn === IPlanOrderItemStatus.COMPLETED_PRODUCTION)
    ) {
      return true;
    }
    return false;
  };

  const disableSplitByGroup = item => {
    if (PROD_CATEG_1(item.materialGroup1)) {
      return (
        (item.orderType === "CTP" ||
          item.orderType === "ATP Future" ||
          item.orderType === "ATP OnHand" ||
          item.orderType === "") &&
        (Number(item.assignQuantity) <= 0 || !item.assignQuantity)
      );
    } else {
      return !(Number(item.assignQuantity) > 0 && !item?.poSubcontract);
    }
  };

  const isDisableSplitItem = item =>
    disableSplitByGroup(item) ||
    loadingSplitItem ||
    item.flagR5 ||
    loading ||
    (splitLineId && item.id !== splitLineId) ||
    isDisableSubmitSplitItem ||
    Number(item.itemQty <= 0);

  const isDisablePlant = item => {
    if (
      (isProductCateg2 &&
        item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY) ||
      (isProductCateg2 &&
        item.itemStatusEn === IPlanOrderItemStatus.PARTIAL_DELIVERY)
    ) {
      return false;
    }
    return (
      (isOrderItemCTP(item) &&
        (item.itemStatusEn === IPlanOrderItemStatus.PLANNING_CLOSE_LOOP ||
          item.itemStatusEn ===
            IPlanOrderItemStatus.PLANNING_ALLOCATED_X_TRIM ||
          item.itemStatusEn === IPlanOrderItemStatus.PRODUCING ||
          item.itemStatusEn === IPlanOrderItemStatus.FULL_COMMITTED_ORDER ||
          item.itemStatusEn === IPlanOrderItemStatus.COMPLETED_PRODUCTION)) ||
      item.itemStatusEn === IPlanOrderItemStatus.PARTIAL_DELIVERY ||
      item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY ||
      item.itemStatusEn === IPlanOrderItemStatus.CANCEL
    );
  };

  const isDisableRequestDelivery = item => {
    if (
      (isProductCateg2 &&
        item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY) ||
      (isProductCateg2 &&
        item.itemStatusEn === IPlanOrderItemStatus.PARTIAL_DELIVERY)
    ) {
      return false;
    }
    return (
      item.itemStatusEn === IPlanOrderItemStatus.PARTIAL_DELIVERY ||
      item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY ||
      item.itemStatusEn === IPlanOrderItemStatus.CANCEL
    );
  };

  const isDisableQty = item => {
    if (
      isProductCateg2 &&
      (item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY ||
        item.itemStatusEn === IPlanOrderItemStatus.PARTIAL_DELIVERY)
    ) {
      return false;
    }

    if (item.hasSplit) {
      return true;
    }

    if (!isProductCateg2 && isOrderCompletedDelivery) {
      return true;
    }

    if (!item.isSplit) {
      const disabledStatuses = [
        IPlanOrderItemStatus.PARTIAL_DELIVERY,
        IPlanOrderItemStatus.COMPLETE_DELIVERY,
        IPlanOrderItemStatus.CANCEL
      ];

      if (
        disabledStatuses.includes(item.itemStatusEn) ||
        disabledActionForCashSale
      ) {
        return true;
      }
    }

    return false;
  };

  const renderActionItem = (item, index) => {
    if (
      isItemDisabled(item) &&
      item.statusCancel &&
      !disabledActionForCashSale
    ) {
      return (
        <Button
          id={`lines[${index}].revertOrderitem`}
          data-testid={`lines[${index}].revertOrderitem`}
          className={classes.btnIcon}
          onClick={() => handleRevertItem(item.itemNo, item)}
          disabled={loading || isFlaggedR5Item || hasAnyFlagR5}
        >
          <SVG src={backIcon} className={classes.backIcon} />
        </Button>
      );
    } else if (item.isSplit) {
      return (
        <Button
          id={`lines[${index}].splitOrderItemCancel`}
          data-testid={`lines.splitOrderItemCancel`}
          className={classes.btnIcon}
          onClick={() => handleDeleteSplit(item.itemNo, item.originalId)}
          disabled={loading || loadingSplitItem || hasAnyFlagR5}
        >
          <SVG src={XCircleOutLine} />
        </Button>
      );
    } else {
      return activeTab === ItemTab.tabA ? (
        <Button
          id={`lines[${index}].splitOrderItem`}
          data-testid={`lines.splitOrderItem`}
          className={classes.btnIcon}
          onClick={() => handleSplitItem(item.id)}
          disabled={isDisableSplitItem(item) || hasAnyFlagR5}
        >
          <SVG src={duplicateIcon} />
        </Button>
      ) : (
        ""
      );
    }
  };

  const initialValue = {
    inquiryMethod: listLineOrder.find(item => item.id === dataInputParameter)
      ?.inquiryMethod,
    changeConsignmentCode: false,
    ConsignmentType: ConsignmentType.CUSTOMER,
    consignmentLocation: ""
  };

  const handleChangeRoute = (route, itemId) => {
    const value = {
      target: {
        value: route
      }
    };
    handleChangeField(value, itemId, "route");
  };

  const mapRequestDateChangeReason = requestDateChangeReason => {
    if (requestDateChangeReason === ReasonForChangeRequestDateEnum.C3) {
      return "C3-Logistics";
    } else if (requestDateChangeReason === ReasonForChangeRequestDateEnum.C4) {
      return "C4-Customer";
    } else if (
      requestDateChangeReason === ReasonForChangeRequestDateEnum.X ||
      !requestDateChangeReason
    ) {
      return "None";
    } else {
      return requestDateChangeReason;
    }
  };

  const handleRefetchChangeOrder = () => {
    refetchChangeOrder();
    setBeingProcessMsg("");
  };
  const showIplanButton = showIplanButtonCheck(currentData);
  const renderCellHeadA = (
    <>
      <TableCellHeader className={classNames(classes.colA0)} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Original Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA1, classes.noBorderRight)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"} className={classes.textRequestDate}>
          {intl.formatMessage({ defaultMessage: "Request Date" })}
        </MyTypography>
        <DatePickerApplyAll
          onApplyAll={handleApplyAllRequestDate}
          minDate={moment()}
        />
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA2, classes.noBorderLeft)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Reason for Change Request Date"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA3} rowSpan={2}>
        <MyTypography variant={"subtitle3"} className={classes.textConfirmDate}>
          {intl.formatMessage({ defaultMessage: "Confirm Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA4, classes.noBorderRight)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "จำนวน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA5, classes.noBorderLeft)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA6, classes.noBorderRight)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "น้ำหนัก" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA7, classes.noBorderLeft)}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA8}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Plant" })}
        </MyTypography>
        <Button
          id="plantApplyAll"
          data-testid="plantApplyAll"
          className={classes.btnApplyAll}
          onClick={setApplyPlant}
          variant={"contained"}
        >
          <MyTypography variant={"caption"}>Apply all</MyTypography>
        </Button>
      </TableCellHeader>

      <TableCellHeader
        className={classNames(classes.colA22, classes.noBorderRight)}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Assign Qty." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classNames(classes.colA23, classes.noBorderLeft)}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader
        className={classes.colA9}
        rowSpan={2}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคา/หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA10}
        rowSpan={2}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคารวมสุทธิ" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA11}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Currency" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA12} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "เงื่อนไขการชำระเงิน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA13}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Cat." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA14}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Shipping Point" })}
        </MyTypography>
        <Button
          id="shippingPointApplyAll"
          data-testid="shippingPointApplyAll"
          className={classes.btnApplyAll}
          onClick={setApplyShippingPoint}
          variant={"contained"}
        >
          <MyTypography variant={"caption"}>Apply all</MyTypography>
        </Button>
      </TableCellHeader>
      <TableCellHeader
        className={classes.colA15}
        rowSpan={2}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Route" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA16} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "วันที่ออก PO" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA17} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PO No." })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader className={classes.colA25} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PR No." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA26} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PR Item" })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader className={classes.colA18} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PO No." })}{" "}
          <span className={classes.normalText}>(Outsource)</span>
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colA18IS} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Status" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader colSpan={3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Delivery Tolerance" })}
        </MyTypography>
      </TableCellHeader>

      {showIplanButton ? (
        <TableCellHeader
          className={classes.colA24}
          rowSpan={2}
          textAlign={"center"}
        >
          <MyTypography variant={"subtitle3"}>( P )</MyTypography>
        </TableCellHeader>
      ) : null}
      <TableCellHeader className={classes.colA18} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Product Group" })}
        </MyTypography>
      </TableCellHeader>
    </>
  );
  const renderCellHeadB = (
    <>
      <TableCellHeader className={classes.colB1} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>ATP/CTP</MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colB2} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>ATP/CTP Detail</MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colB3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Block" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colB4} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Run" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colB5} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Paper Machine" })}
        </MyTypography>
      </TableCellHeader>
    </>
  );
  const renderCellHeadC = (
    <>
      <TableCellHeader className={classes.colC1} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ship-to Party" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC2} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Internal Comments to Warehouse"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "External Comments to Customer"
          })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader className={classes.colC3} textAlign={"center"}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({
            defaultMessage: "Remark"
          })}
        </MyTypography>
      </TableCellHeader>
    </>
  );

  const renderCellBodyA = (item, index) => (
    <>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: !item.hasSplit && splitLineId
          })}
        >
          {item.originalRequestDate ? item.originalRequestDate : "-"}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderRight
        )}
        align={"center"}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames({
              [classes.disabledLine]: !item.hasSplit && splitLineId
            })}
          >
            {item.requestDate
              ? moment(item.requestDate).format("DD/MM/YYYY")
              : ""}
          </MyTypography>
        ) : (
          <>
            <DatePicker
              id={`lines[${index}].requestDate`}
              data-testid={`lines.requestDate`}
              name={"requestDate"}
              value={item.requestDate}
              onChange={e => handleChangeField(e, item.itemNo, "requestDate")}
              noBlock
              error={item.errorDate}
              // minDate={moment()}
              disabled={
                item.hasSplit ||
                (isProductCateg2 ? false : isOrderCompletedDelivery) ||
                (isDisableRequestDelivery(item) && !item.isSplit)
              }
            />
            {item.errorDate && item.requestDate ? (
              <div className={classes.errorTextRequestDate}>
                {item?.errorDateMessage
                  ? item?.errorDateMessage
                  : "กรุณาเปลี่ยน “Request Date” (ไม่สามารถใส่วันที่ผ่านมาแล้วได้)"}
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </TableCell>
      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderLeft
        )}
        // className={classes.noBorderLeft}
        align={isItemDisabled(item) ? "center" : "left"}
      >
        {isItemDisabledRequestDateChangeReason(item) ? (
          <MyTypography variant={"body3"}>
            {mapRequestDateChangeReason(item.requestDateChangeReason)}
          </MyTypography>
        ) : (
          <SingleSelectField
            id={`lines[${index}].reasonForChangeRequestDate`}
            data-testid={`lines.reasonForChangeRequestDate`}
            InputProps={{
              inputProps: {
                "data-testid": "lines.reasonForChangeRequestDate-input"
              }
            }}
            disabled={
              item.hasSplit || item.isSplit || item.flagR5 || hasAnyFlagR5
            }
            name={"requestDateChangeReason"}
            placeholder={"Select"}
            choices={[
              {
                value: ReasonForChangeRequestDateEnum.X,
                label: "None"
              },
              {
                value: ReasonForChangeRequestDateEnum.C3,
                label: "C3-Logistics"
              },
              { value: ReasonForChangeRequestDateEnum.C4, label: "C4-Customer" }
            ]}
            onChange={e =>
              handleChangeField(e, item.itemNo, "requestDateChangeReason")
            }
            value={
              item.requestDateChangeReason || ReasonForChangeRequestDateEnum.X
            }
          />
        )}
      </TableCell>
      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderLeft
        )}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId,
            [classes.wrongDate]: item.requestDate !== item.confirmedDate,
            [classes.matchDate]: item.requestDate === item.confirmedDate
          })}
        >
          {item.confirmedDate && !item.isSplit
            ? moment(item.confirmedDate).format("DD/MM/YYYY")
            : "-"}
        </MyTypography>
      </TableCell>

      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderRight,
          classes.colA4
        )}
        // className={classes.noBorderRight}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames({
              [classes.disabledLine]: !item.hasSplit && splitLineId
            })}
          >
            <FormattedNumber
              value={item.itemQty}
              {...(SALE_CATEG_1(item?.salesUnit)
                ? { minimumFractionDigits: 3, maximumFractionDigits: 3 }
                : {})}
            />
          </MyTypography>
        ) : (
          <NumberFormat
            id={`lines[${index}].quantity`}
            testId={`lines.quantity`}
            inputDisabled={isDisableQty(item)}
            allowNegative={false}
            allowLeadingZeros={!SALE_CATEG_1(item?.salesUnit)}
            disabled={isDisableQty(item)}
            value={item.itemQty}
            onChange={e => handleChangeField(e, item.itemNo, "quantity")}
            name={"quantity"}
            error={item.errorQuantity || !item.quantity}
            placeholder={SALE_CATEG_1(item?.salesUnit) ? "0.000" : "0"}
            decimalScale={SALE_CATEG_1(item?.salesUnit) ? 3 : 0}
            rightAlignPlaceholder={SALE_CATEG_1(item?.salesUnit)}
            fixedDecimalScale={SALE_CATEG_1(item?.salesUnit)}
          />
        )}
        {item.errorQuantity && item.quantity ? (
          <div className={classes.errorText}>
            {item?.errorText
              ? item?.errorText
              : "จำนวนที่สั่งมีมากกว่าจำนวนคงเหลือ"}
          </div>
        ) : (
          ""
        )}
      </TableCell>
      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderLeft
        )}
        align={"center"}
        // className={classes.noBorderLeft}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          {item?.salesUnit}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderRight
        )}
        align={"center"}
        // className={classes.noBorderRight}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          {item.quantity ? (
            <DecimalFormat
              value={
                item.weightUnitTon === WEIGHT_UNIT.TON
                  ? ((item.saleQtyFactor / 1000) * item.quantity) /
                    item.saleQtyDivision
                  : (item.saleQtyFactor * item.quantity) / item.saleQtyDivision
              }
              isGrayDecimal
              countDecimal={3}
            />
          ) : (
            "0"
          )}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderLeft
        )}
        // className={classes.noBorderLeft}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames({
              [classes.disabledLine]: !item.hasSplit && splitLineId
            })}
          >
            {item.weightUnitTon}
          </MyTypography>
        ) : (
          <SingleSelectField
            id={`lines[${index}].unit`}
            data-testid={`lines.unit`}
            disabled={item.hasSplit || item.isSplit}
            InputProps={{
              inputProps: {
                "data-testid": "lines.unit-input"
              },
              classes: { input: classes.txtInputSelect }
            }}
            choices={[
              {
                label: <MyTypography variant={"subtitle3"}>TON</MyTypography>,
                value: WEIGHT_UNIT.TON
              },
              {
                label: <MyTypography variant={"subtitle3"}>Kg.</MyTypography>,
                value: WEIGHT_UNIT.KG
              }
            ]}
            onChange={e => handleChangeField(e, item.itemNo, "weightUnitTon")}
            placeholder={"Select"}
            value={item.weightUnitTon}
            name={"weightUnitTon"}
          />
        )}
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
        align={"center"}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames({
              [classes.disabledLine]: !item.hasSplit && splitLineId
            })}
          >
            {item.plant}
          </MyTypography>
        ) : (
          <SingleTextField
            id={`lines[${index}].plant`}
            data-testid={`lines.plant`}
            InputProps={{
              inputProps: {
                "data-testid": "lines.plant-input"
              }
            }}
            disabled={
              item.hasSplit ||
              (isProductCateg2 ? false : isOrderCompletedDelivery) ||
              item.isSplit ||
              isDisablePlant(item)
            }
            name={"plant"}
            value={item.plant}
            onChange={e => handleChangeField(e, item.itemNo, "plant")}
            maxLengthProps={4}
            regex={REGEX_ONLY_NUMBER_CHARACTER}
          />
        )}
      </TableCell>

      <TableCell align={"center"} className={classes.noBorderRight}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId,
            [classes.disabledItem]: isItemDisabled(item)
          })}
        >
          <FormattedNumber
            value={
              +(
                (isKO1KO9(item.materialGroup1)
                  ? item?.assignQuantity
                  : item?.comfirmQty) ?? 0
              )
            }
          />
        </MyTypography>
      </TableCell>
      <TableCell align={"center"} className={classes.noBorderLeft}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId,
            [classes.disabledItem]: isItemDisabled(item)
          })}
        >
          {item?.salesUnit}
        </MyTypography>
      </TableCell>

      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
        align={"right"}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          <DecimalFormat
            value={item?.pricePerUnit}
            isGrayDecimal={false}
            countDecimal={2}
          />
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
        align={"right"}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          {item.quantity ? (
            <DecimalFormat
              value={
                isProductCateg2
                  ? getNetPriceForProductGroup2(item.itemQty, item.pricePerUnit)
                  : getNetPriceForProductGroup1(
                      item.itemQty,
                      item.pricePerUnit,
                      item.saleQtyFactor / 1000
                    )
              }
              isGrayDecimal={false}
              countDecimal={2}
            />
          ) : (
            "0"
          )}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
        align={"center"}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          {dataOrder?.currency || ""}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          {item.paymentTerm}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          {item.itemCategory}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
        align={"center"}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames({
              [classes.disabledLine]: !item.hasSplit && splitLineId
            })}
          >
            {item.shippingPoint}
          </MyTypography>
        ) : (
          <SingleTextField
            id={`lines[${index}].shippingPoint`}
            data-testid={`lines.shippingPoint`}
            InputProps={{
              inputProps: {
                "data-testid": "lines.shippingPoint-input"
              }
            }}
            disabled={item.hasSplit || item.isSplit}
            value={item.shippingPoint}
            name={"shippingPoint"}
            onChange={e => handleChangeField(e, item.itemNo, "shippingPoint")}
            maxLengthProps={4}
          />
        )}
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        <div className={classes.rowFlex}>
          {isItemDisabled(item) ? (
            <MyTypography
              variant={"body3"}
              className={classNames({
                [classes.disabledLine]: !item.hasSplit && splitLineId
              })}
            >
              {item?.routeId ? `${item?.routeId} - ${item?.routeName}` : ""}
            </MyTypography>
          ) : (
            <SearchRoute
              route={
                item?.routeId ? `${item?.routeId} - ${item?.routeName}` : ""
              }
              setRoute={handleChangeRoute}
              contractNo={dataOrder?.contractNo}
              disabled={item.hasSplit || item.isSplit}
              itemId={item.itemNo}
              btnClsNames={classes.searchbtn}
            />
          )}
        </div>
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          {item.poDate ? moment(item.poDate).format("DD/MM/YYYY") : ""}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames({
              [classes.disabledLine]: !item.hasSplit && splitLineId
            })}
          >
            {item.poNumber}
          </MyTypography>
        ) : (
          <SingleTextField
            id={`lines[${index}].poNo`}
            data-testid={`lines.poNo`}
            InputProps={{
              inputProps: {
                "data-testid": "lines.poNo-input"
              }
            }}
            disabled={item.hasSplit || item.isSplit}
            onChange={e => handleChangeField(e, item.itemNo, "poNumber")}
            value={item.poNumber}
            name={"poNumber"}
          />
        )}
      </TableCell>

      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item?.prNo}
        </MyTypography>
      </TableCell>

      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item?.prItem}
        </MyTypography>
      </TableCell>

      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          {item.poSubcontract}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          {!item.isSplit ? item.itemStatusEnDisplayText : ""}
        </MyTypography>
      </TableCell>
      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderRight
        )}
        align={"center"}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames({
              [classes.disabledLine]: !item.hasSplit && splitLineId
            })}
          >
            {item.underDeliveryTol}
          </MyTypography>
        ) : (
          <SingleTextFieldUnblock
            id={`lines[${index}].deliveryToleranceUnder`}
            data-testid={`lines.deliveryToleranceUnder`}
            InputProps={{
              inputProps: {
                "data-testid": "lines.deliveryToleranceUnder-input"
              }
            }}
            onChange={e =>
              handleChangeField(e, item.itemNo, "underDeliveryTol")
            }
            value={item.deliveryTolUnlimited ? "0" : item.underDeliveryTol}
            name={"underDeliveryTol"}
            className={classes.inputUnlimit}
            regex={REGEX_ONLY_NUMBER}
            disabled={
              item.deliveryTolUnlimited || item.hasSplit || item.isSplit
            }
            numberLimit={100}
          />
        )}
      </TableCell>
      <TableCell
        align={"center"}
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderRight,
          classes.noBorderLeft
        )}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames({
              [classes.disabledLine]: !item.hasSplit && splitLineId
            })}
          >
            {item.overDeliveryTol}
          </MyTypography>
        ) : (
          <SingleTextFieldUnblock
            id={`lines[${index}].deliveryToleranceOver`}
            data-testid={`lines.deliveryToleranceOver`}
            InputProps={{
              inputProps: {
                "data-testid": "lines.deliveryToleranceOver-input"
              }
            }}
            onChange={e => handleChangeField(e, item.itemNo, "overDeliveryTol")}
            value={item.deliveryTolUnlimited ? "0" : item.overDeliveryTol}
            name={"overDeliveryTol"}
            className={classes.inputUnlimit}
            regex={REGEX_ONLY_NUMBER}
            disabled={
              item.deliveryTolUnlimited || item.hasSplit || item.isSplit
            }
            numberLimit={100}
          />
        )}
      </TableCell>
      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          },
          classes.noBorderLeft
        )}
        align={"center"}
      >
        <MyTypography
          variant={"body3"}
          className={classNames(classes.cellFlexCenter, {
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId
          })}
        >
          <Checkbox
            id={`lines[${index}].deliveryToleranceUnlimitedCheckbox`}
            data-testid={`lines[${index}].deliveryToleranceUnlimitedCheckbox`}
            onChange={e =>
              handleChangeField(
                e,
                item.itemNo,
                "deliveryTolUnlimited",
                e.target.checked
              )
            }
            checked={item.deliveryTolUnlimited}
            className={classNames(classes.checkBoxDisabled, "colCheck")}
            disabled={isItemDisabled(item) || item.hasSplit || item.isSplit}
          />
          Unlimited
        </MyTypography>
      </TableCell>

      {showIplanButton ? (
        <TableCell align={"center"} className={classes.cellBtn}>
          <Button
            id={`lines[${index}].inputParameterOpen`}
            data-testid={`lines.inputParameterOpen`}
            variant={"contained"}
            color={"secondary"}
            className={classes.btnExternal}
            onClick={() => handleOpenInputParameter(item.id)}
            disabled={
              isItemDisabled(item) ||
              isDisableCtpWithCondition(item) ||
              item.hasSplit ||
              item.isSplit
            }
          >
            <SVG src={ExternalLinkTeal} />
          </Button>
        </TableCell>
      ) : null}
      <TableCell>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]: isItemDisabled(item)
          })}
        >
          {item?.materialGroup1 + `: ` + item?.materialGroup1Desc}
        </MyTypography>
      </TableCell>
    </>
  );
  const renderCellBodyB = item => (
    <>
      <TableCell
        className={classNames(
          {
            [classes.disabledItem]: isItemDisabled(item)
          }
          // classes.noBorderRight,
        )}
        align={"center"}
      >
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId,
            [classes.disabledItem]: isItemDisabled(item)
          })}
        >
          {item?.atp}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId,
            [classes.disabledItem]: isItemDisabled(item)
          })}
        >
          {item?.atpDetails}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId,
            [classes.disabledItem]: isItemDisabled(item)
          })}
        >
          {item?.block}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId,
            [classes.disabledItem]: isItemDisabled(item)
          })}
        >
          {item?.run}
        </MyTypography>
      </TableCell>
      <TableCell align={"center"}>
        <MyTypography
          variant={"body3"}
          className={classNames({
            [classes.disabledLine]:
              isItemDisabled(item) && !item.hasSplit && splitLineId,
            [classes.disabledItem]: isItemDisabled(item)
          })}
        >
          {item?.paperMachine}
        </MyTypography>
      </TableCell>
    </>
  );
  const renderCellBodyC = (item, index) => (
    <>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        <div className={classes.rowFlexSpace}>
          <pre
            style={{
              wordWrap: "break-word",
              whiteSpace: "pre-wrap",
              margin: 0
            }}
          >
            <MyTypography
              variant={"body3"}
              className={classNames({
                [classes.disabledLine]:
                  isItemDisabled(item) && !item.hasSplit && splitLineId
              })}
              data-testid="shipTo-text"
            >
              {item?.shipTo ? item?.shipTo : ""}
            </MyTypography>
          </pre>
          {!isItemDisabled(item) &&
          shipToData?.getSapRealtimePartner?.response.length > 1 ? (
            <Button
              id={`lines[${index}].changeShipToPartyButton`}
              data-testid={`lines.changeShipToPartyButton`}
              variant={"outlined"}
              color={"secondary"}
              className={classes.btnThin}
              onClick={() => handleOpenAddress(item)}
              disabled={item.hasSplit || item.isSplit}
            >
              <MyTypography variant={"body3"}>
                {intl.formatMessage({ defaultMessage: "แก้ไข" })}
              </MyTypography>
            </Button>
          ) : (
            ""
          )}
        </div>
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames(
              { [classes.disabledLine]: !item.hasSplit && splitLineId },
              classes.pre
            )}
          >
            {item.internalCommentsToWarehouse}
          </MyTypography>
        ) : (
          <TextAreaField
            id={`lines[${index}].internalCommentsToWarehouse`}
            data-testid={`lines.internalCommentsToWarehouse`}
            maxLength={1320}
            className={classes.additionaltxtarea}
            lineLimit={132}
            verticalResizingOnly
            disabled={item.hasSplit || item.isSplit}
            name={"internalCommentsToWarehouse"}
            onChange={e =>
              handleChangeField(e, item.itemNo, "internalCommentsToWarehouse")
            }
            value={item.internalCommentsToWarehouse}
          />
        )}
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames(
              { [classes.disabledLine]: !item.hasSplit && splitLineId },
              classes.pre
            )}
          >
            {item.externalCommentsToCustomer}
          </MyTypography>
        ) : (
          <TextAreaField
            id={`lines[${index}].externalCommentsToCustomer`}
            data-testid={`lines.externalCommentsToCustomer`}
            maxLength={1320}
            lineLimit={132}
            className={classes.additionaltxtarea}
            verticalResizingOnly
            disabled={item.hasSplit || item.isSplit}
            name={"externalCommentsToCustomer"}
            onChange={e =>
              handleChangeField(e, item.itemNo, "externalCommentsToCustomer")
            }
            value={item.externalCommentsToCustomer}
          />
        )}
      </TableCell>
      <TableCell
        className={classNames({
          [classes.disabledItem]: isItemDisabled(item)
        })}
      >
        {isItemDisabled(item) ? (
          <MyTypography
            variant={"body3"}
            className={classNames(
              { [classes.disabledLine]: !item.hasSplit && splitLineId },
              classes.pre
            )}
          >
            {item?.shippingMark}
          </MyTypography>
        ) : (
          <TextAreaField
            id={`lines[${index}].shippingMark`}
            data-testid={`lines.shippingMark`}
            maxLength={1320}
            minWidth={248}
            lineLimit={132}
            verticalResizingOnly
            disabled={item.hasSplit || item.isSplit}
            name={"shippingMark"}
            onChange={e => handleChangeField(e, item.itemNo, "shippingMark")}
            value={item?.shippingMark}
          />
        )}
      </TableCell>
    </>
  );

  const renderRowSubmitSplit = (item, index) => {
    if (splitLineId && item.isSplit) {
      const nextItem = currentData.filter(
        line => line.statusCancel !== "Delete"
      )[index + 1];
      if (!nextItem || (nextItem && !nextItem.isSplit)) {
        return (
          <TableRow key={item.itemNo} className={classes.rowSplit}>
            <TableCell
              colSpan={5}
              align={"right"}
              className={classes.cellSplit}
            >
              <Button
                id={`lines[${index}].splitOrderItemSave`}
                data-testid={`lines.splitOrderItemSave`}
                variant={"contained"}
                color={"secondary"}
                className={classNames("defaultB", classes.btnSubmit)}
                onClick={onSubmitSplit}
                disabled={
                  loadingSplitItem ||
                  isDisableSubmitSplitItem ||
                  item.errorQuantity
                }
              >
                <MyTypography variant={"subtitle3"}>
                  {intl.formatMessage({ defaultMessage: "บันทึก Split Item" })}
                </MyTypography>
              </Button>
            </TableCell>
            {activeTab === ItemTab.tabA && <TableCell colSpan={29}></TableCell>}
            {activeTab === ItemTab.tabB && <TableCell colSpan={8}></TableCell>}
            {activeTab === ItemTab.tabC && <TableCell colSpan={4}></TableCell>}
          </TableRow>
        );
      }
    }
  };

  const allowAccordingToIplan = useMemo(() => {
    if (openInputParameter) {
      const inputParameter = currentData.find(
        item => item.id === dataInputParameter
      );
      return inputParameter?.allowChangeInquiryMethod;
    }
    return false;
  }, [dataInputParameter, openInputParameter]);
  return (
    <div className={classes.root}>
      <div className={classes.topBox}>
        <FullScreenButton />
      </div>
      <div className={classes.tabBox}>
        {renderCollection(tabList, tab => {
          if (tab.code === ItemTab.tabB && isProductCateg2) {
            // Hide tabB when isProductCateg2 is true
            return null;
          }
          if (tab.code === ItemTab.tabD && !isCashSaleOrder) {
            return null;
          }

          return (
            <div
              key={tab.code}
              className={classNames(
                activeTab === tab.code ? classes.zMax : classes[tab.index]
              )}
            >
              <Button
                id={tab.id}
                data-testid={tab.id}
                onClick={() => onTabClick(tab?.code)}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") {
                    onTabClick(tab?.code);
                  }
                }}
                className={classNames(
                  !tab.first && classes.tabB,
                  classes.tableTab,
                  activeTab === tab.code
                    ? classes.tableTabActive
                    : classes.tableTabInactive
                )}
              >
                <MyTypography
                  variant={"body2"}
                  className={classNames(
                    activeTab === tab.code
                      ? classes.innerTabActive
                      : classes.innerTab
                  )}
                >
                  {tab.title}
                </MyTypography>
              </Button>
            </div>
          );
        })}
      </div>

      {[ItemTab.tabA, ItemTab.tabB, ItemTab.tabC].includes(activeTab) ? (
        <>
          <div className={classes.boxTable} ref={containerRef}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCellHeader
                    className={classes.cellFrezze0}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                    textAlign={"center"}
                  >
                    <Checkbox
                      id="deleteCheckboxAll"
                      data-testid="deleteCheckboxAll"
                      checked={
                        listLineOrder.filter(item => !isItemDisabled(item))
                          .length > 0 &&
                        listElements.length ===
                          listLineOrder.filter(item => !isItemDisabled(item))
                            .length
                      }
                      indeterminate={
                        listElements.length > 0 &&
                        listElements.length <
                          listLineOrder.filter(item => !isItemDisabled(item))
                            .length
                      }
                      onClick={handleCheckboxAll}
                    />
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.cellFrezze1}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                    direction={
                      sort.sort === DomesticOrderSortField.item_no
                        ? getArrowDirection(sort.asc)
                        : undefined
                    }
                    arrowPosition="right"
                    onClick={() => onSort(DomesticOrderSortField.item_no)}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Item No." })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.cellFrezze2}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Material Code" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.cellFrezze3}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({
                        defaultMessage: "Material Description."
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.cellFrezze4}
                    rowSpan={activeTab === ItemTab.tabA ? 2 : 1}
                  />
                  {activeTab === ItemTab.tabA && renderCellHeadA}
                  {activeTab === ItemTab.tabB && renderCellHeadB}
                  {activeTab === ItemTab.tabC && renderCellHeadC}
                </TableRow>
                {activeTab === ItemTab.tabA && (
                  <TableRow>
                    <TableCell
                      align={"center"}
                      className={classNames(
                        classes.colA19,
                        classes.noBorderRight,
                        classes.cellUnlimited
                      )}
                    >
                      <MyTypography
                        variant={"body3"}
                        className={classes.cellSize13}
                      >
                        Under (%)
                      </MyTypography>
                    </TableCell>
                    <TableCell
                      align={"center"}
                      className={classNames(
                        classes.colA20,
                        classes.noBorderRight,
                        classes.noBorderLeft,
                        classes.cellUnlimited
                      )}
                    >
                      <MyTypography
                        variant={"body3"}
                        className={classes.cellSize13}
                      >
                        Over (%)
                      </MyTypography>
                    </TableCell>
                    <TableCell
                      align={"center"}
                      className={classNames(
                        classes.colA21,
                        classes.noBorderLeft,
                        classes.cellUnlimited,
                        classes.cellHeadCheck
                      )}
                    >
                      <MyTypography
                        variant={"body3"}
                        className={classNames(
                          classes.cellSize13,
                          classes.cellFlexCenter
                        )}
                      >
                        <Checkbox
                          id="deliveryToleranceUnlimitedCheckboxAll"
                          data-testid="deliveryToleranceUnlimitedCheckboxAll"
                          className="colCheck"
                          onClick={handleClickCheckBoxUnlimitAll}
                          indeterminate={getIndeterminateAllLimit()}
                          checked={getCheckedSelectAllUnlimit()}
                        />
                        Unlimited
                      </MyTypography>
                    </TableCell>
                  </TableRow>
                )}
              </TableHead>
              <TableBody>
                {currentData
                  .filter(orderItem => orderItem.statusCancel !== "Delete")
                  .map((item, index) => (
                    <React.Fragment key={item.itemNo}>
                      <TableRow
                        // className={classNames({
                        //   [classes.disabledItem]: isItemDisabled(item)
                        // })}
                        className={classNames({
                          [classes.disabledItem]: isItemDisabled(item),
                          [classes.rowSplit]: item.hasSplit || item.isSplit,
                          [classes.rowNonSplit]:
                            !item.hasSplit && !item.isSplit && splitLineId
                        })}
                      >
                        <TableCell
                          className={classes.cellFrezze0}
                          align={"center"}
                        >
                          {!item.isSplit ? (
                            <Checkbox
                              id={`lines[${index}].deleteCheckbox`}
                              data-testid={`lines[${index}].deleteCheckbox`}
                              checked={
                                isItemDisabled(item, true)
                                  ? false
                                  : isSelected(item.itemNo)
                              }
                              disabled={
                                isItemDisabled(item, true) ||
                                splitLineId === item.id
                              }
                              onClick={() => toggle(item.itemNo)}
                            />
                          ) : null}
                        </TableCell>
                        <TableCell
                          className={classes.cellFrezze1}
                          align={"center"}
                        >
                          <MyTypography
                            variant={"body3"}
                            className={classNames({
                              [classes.disabledItem]: isItemDisabled(item),
                              [classes.disabledLine]:
                                isItemDisabled(item) &&
                                !item.hasSplit &&
                                splitLineId
                            })}
                          >
                            {item.isSplit ? "-" : item.itemNo}
                          </MyTypography>
                        </TableCell>
                        <TableCell className={classes.cellFrezze2}>
                          <MyTypography
                            variant={"body3"}
                            className={classNames({
                              [classes.disabledItem]: isItemDisabled(item),
                              [classes.disabledLine]:
                                isItemDisabled(item) &&
                                !item.hasSplit &&
                                splitLineId
                            })}
                          >
                            {item?.material}
                          </MyTypography>
                        </TableCell>
                        <TableCell className={classes.cellFrezze3}>
                          <MyTypography
                            variant={"body3"}
                            className={classNames({
                              [classes.disabledItem]: isItemDisabled(item),
                              [classes.disabledLine]:
                                isItemDisabled(item) &&
                                !item.hasSplit &&
                                splitLineId
                            })}
                          >
                            {item?.materialDesc}
                          </MyTypography>
                          {isItemDisabled(item) ? (
                            <MyTypography
                              variant={"caption"}
                              className={classNames({
                                [classes.boxCancel]:
                                  item.statusCancel === "Cancel",
                                [classes.boxDelete]:
                                  item.statusCancel === "Delete"
                              })}
                            >
                              {item.statusCancel === "Cancel"
                                ? "Cancel 93"
                                : item.statusCancel}
                            </MyTypography>
                          ) : (
                            ""
                          )}
                        </TableCell>
                        <TableCell
                          className={classes.cellFrezze4}
                          align={"center"}
                        >
                          {renderActionItem(item, index)}
                        </TableCell>
                        {activeTab === ItemTab.tabA &&
                          renderCellBodyA(item, index)}
                        {activeTab === ItemTab.tabB && renderCellBodyB(item)}
                        {activeTab === ItemTab.tabC &&
                          renderCellBodyC(item, index)}
                      </TableRow>
                      {renderRowSubmitSplit(item, index)}
                    </React.Fragment>
                  ))}
              </TableBody>
            </Table>
            <StickyHorizontalScrollBar
              container={containerRef}
              reRender={reRender}
              // bottom={fullScreen ? 0 : 173}
            />
          </div>
          <TablePaginationCustom
            hasNextPage={loading || hasNextPage}
            hasPreviousPage={loading || hasPreviousPage}
            onNextPage={onNextPage}
            onPreviousPage={onPreviousPage}
            totalCount={currentData.length}
            selectColor="#007E92"
            settings={settings}
            onUpdateListSettings={onUpdateListSettings}
            isBackFistPage
            isNextLastPage
            latestPageItemNumber={currentData.length}
            onNextLastPage={onNextLastPage}
            onPreviousFirstPage={onPreviousFirstPage}
            disabled={loading}
            rowNumberSet={BIG_ROW_NUMBER_SET}
          />
        </>
      ) : activeTab === ItemTab.tabD && cashSaleFormProps ? (
        <CashSaleForm {...cashSaleFormProps} />
      ) : null}

      {openAddress && (
        <ModalAddress
          address={shipToData?.getSapRealtimePartner?.response || []}
          handleApplyAddress={applyAddressShipTo}
          initAddress={dataModalAddress.initAddress}
          visible={openAddress}
          onClose={handleCloseAddress}
        />
      )}
      <PopoverApplyAll
        key={`apply_${componentKey}`}
        title={dataApplyAll.title}
        onOk={handleApplyAll}
        open={openApplyAll}
        onClose={() => setOpenApplyAll(false)}
        anchorEl={dataApplyAll.anchorEl}
        placeholder={dataApplyAll.placeholder}
        maxLengthInput={dataApplyAll.maxLength}
        regexInput={dataApplyAll.regex}
      />
      <ModalInputParameter
        allowAccordingToIplan={allowAccordingToIplan}
        open={openInputParameter}
        onClose={() => setOpenInputParameter(false)}
        onSave={onSaveInputParameter}
        initialValue={initialValue}
        orderId={dataInputParameter}
        modalData={listLineOrder.find(item => item.id === dataInputParameter)}
      />
      <DialogConfirmSplit
        open={openConfirmSplit}
        onClose={() => setOpenConfirmSplit(false)}
        onOk={onOkConfirmSplit}
        loading={loadingSplitItem}
      />
      <DialogSubmitOrder onClose={() => null} open={openLoadingSubmit} />
      <OrderBeingProcessError
        open={!!beingProcessMsg}
        onClose={() => handleRefetchChangeOrder()}
        errorMessage={beingProcessMsg}
      />
      <DialogProcessing
        open={loadingSplitItem}
        description={"ระบบกำลังประมวลผล กรุณารอสักครู่"}
      />
      <DialogSplitError
        open={dialogSplitError}
        onConfirm={onAcknowledgeSplitError}
        onCancel={onAcknowledgeSplitError}
        errorSource={errorSource}
        errorItems={errorItems}
      />
    </div>
  );
};

export default ItemDetailsTabEdit;
